<template>
  <v-container style="width: 100%;">
    <Overview/>
  </v-container>
</template>

<script>
// @ is an alias to /src
import Overview from "@/components/settings/Overview.vue";

export default {
  name: "settings",
  components: {
    Overview
  }
};
</script>
